import React from "react";
import FeatherIconCom from "./FeatherIcon/FeatherIconCom";
import { toast } from "react-toastify";
import { Container, Row, FormGroup, Label, Input } from "reactstrap";
import { CopyText, Markup } from "../../Constant";
import { Btn } from "../../AbstractElements";

const IconMarkUp = (props) => {
  const closeIconContainer = () => {
    document.getElementsByClassName("icon-hover-bottom")[0].style.display = "none";
  };
  if (props.itag !== "" && props.icons !== "") {
    document.getElementsByClassName("icon-hover-bottom")[0].style.display = "block";
  }

  const buttonClick = async () => {
    await navigator.clipboard.writeText(props.itag.iTag);
    toast.info("Code Copied to clipboard !", { position: "bottom-right", theme: "colored" });
  };
  return (
    <div className="icon-hover-bottom p-fixed fa-fa-icon-show-div">
      <Container fluid={true}>
        <Row>
          <div className="icon-popup">
            <div className="close-icon" onClick={() => closeIconContainer()}>
              <i className="icofont icofont-close"></i>
            </div>
            {<div className="icon-first">{props.icons.feathericon ? <FeatherIconCom iconName={props.icons.feathericon} /> : <i id="icon_main" className={props.icons.icon}></i>}</div>}
            <div className="icon-class">
              <Label className="icon-title"></Label>
              <span id="fclass1"></span>
            </div>
            <div className="icon-last icon-last">
              <Label className="icon-title">{Markup}</Label>
              <div className="form-inline">
                <FormGroup className="form-group">
                  <Input type="text" className="inp-val form-control m-r-10" defaultValue={props.itag.iTag} id="input_copy" />
                  <Btn color="primary" className="notification" onClick={buttonClick}>
                    {CopyText}
                  </Btn>
                </FormGroup>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default IconMarkUp;
